import { DateTime } from "luxon";
import type { AttachmentDto, AttachmentType } from "../../../api/types";
import type { AssignedState, Filters, FormatCategory } from "./types";

const matchesAssigned = (flag: boolean, state: AssignedState): boolean => {
  switch (state) {
    case "any":
      return true;
    case "assigned":
      return flag;
    case "unassigned":
      return !flag;
  }
};

const toFormatCategory = (contentType: AttachmentType): FormatCategory =>
  contentType === "application/pdf" ? "pdf" : "image";

export const filterAttachments = (
  attachments: AttachmentDto[],
  filters: Filters,
): AttachmentDto[] => {
  const pattern = filters.namePattern.trim().toLowerCase();
  const from = filters.from
    ? DateTime.fromISO(filters.from).startOf("day")
    : null;
  const to = filters.to ? DateTime.fromISO(filters.to).endOf("day") : null;

  return attachments.filter((a) => {
    if (!matchesAssigned(a.hasInvoice, filters.invoice)) return false;
    if (!matchesAssigned(a.hasTransaction, filters.transaction)) return false;
    if (
      filters.formats.length > 0 &&
      !filters.formats.includes(toFormatCategory(a.contentType))
    )
      return false;
    if (pattern && !a.filename.toLowerCase().includes(pattern)) return false;
    if (from || to) {
      const created = DateTime.fromISO(a.createdAt);
      if (!created.isValid) return false;
      if (from && created < from) return false;
      if (to && created > to) return false;
    }
    return true;
  });
};
